var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"diagnostic-overview"},[_c('div',{staticClass:"diagnostic-overview__title text-center"},[_vm._v(" "+_vm._s(_vm.$t('dashboard.photoAnalysis.label.simplifiedSkinDiagnostic'))+" ")]),_c('scores-spider-chart')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }